import Footer from "../components/Footer";
import Treasure from "../assets/treasure.png";

export default function Contact() {
  return (
    <section id="contact" className="deepest min-vh-100">
      <div className="container-fluid px-3">
        <div className="row px-3 px-md-5 min-vh-100 flex-column flex-md-row align-items-center">
          <div className="col-12 col-md-6 d-flex align-items-center h-100 flex-grow-1 flex-md-grow-0">
            {/* Contact Section */}
            <div className="d-flex flex-column fs-xs-base">
              <h2 className="mt-3 mt-md-0 fs-1 fw-bold">GET IN TOUCH</h2>
              <div className="ps-2">
                <h3 className="mt-3 mb-4">Let's Work!</h3>
                <p>You can reach out to me via any of the channels listed below:</p>
                <div className="d-flex flex-column mt-3 gap-4" style={{ maxWidth: '340px' }}>
                  <a 
                    className="btn-bubble px-3 gap-3 justify-content-start"
                    href="mailto:marcojalenyu@gmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Send Email"
                  >
                    <i className="bi bi-envelope-fill"></i>
                    <span>marcojalenyu@gmail.com</span>
                  </a>
                  <a
                    className="btn-bubble px-3 gap-3 justify-content-start"
                    href="https://www.linkedin.com/in/marcojalenyu/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit LinkedIn Profile"
                  >
                    <i className="bi bi-linkedin"></i>
                    <span>Marco Yu</span>
                  </a>
                </div>
              </div>              
            </div>
          </div>
          {/* Image Section */}
          <div className="col-12 col-md-6 d-none d-md-flex min-vh-100 justify-content-center align-items-end">
            <img
              src={Treasure}
              alt="Treasure"
              className="img-fluid"
              style={{ height: '100%', width: 'auto', objectFit: 'contain', maxWidth: '50%' }}
            />
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
}